import { render, staticRenderFns } from "./SupplierPurchaseDashboard.vue?vue&type=template&id=cc83352c&lang=pug&"
import script from "./SupplierPurchaseDashboard.vue?vue&type=script&lang=js&"
export * from "./SupplierPurchaseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPurchaseDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports